import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, alpha, Typography } from '@mui/material';
import { forwardRef } from 'react';
import theme from '../../styles/theme/index.js';
import '../Icons/Add.js';
import '../Icons/Application.js';
import '../Icons/AppStore.js';
import '../Icons/Arrow.js';
import '../Icons/At.js';
import '../Icons/Attach.js';
import '../Icons/Bank.js';
import '../Icons/Battery.js';
import '../Icons/Bell.js';
import '../Icons/Blocked.js';
import '../Icons/Calendar.js';
import '../Icons/Card.js';
import '../Icons/CaretDown.js';
import '../Icons/CaretLeft.js';
import '../Icons/CaretRight.js';
import '../Icons/CaretUp.js';
import '../Icons/Checkbox.js';
import '../Icons/CheckboxChecked.js';
import '../Icons/CheckboxIndeterminate.js';
import '../Icons/ChevronLeft.js';
import '../Icons/ChevronRight.js';
import '../Icons/Company.js';
import '../Icons/Copy.js';
import '../Icons/Currency.js';
import '../Icons/Customers.js';
import '../Icons/Dash.js';
import '../Icons/Dashboard.js';
import '../Icons/DirectionDown.js';
import '../Icons/DirectionUp.js';
import '../Icons/Document.js';
import '../Icons/DoubleChevronLeft.js';
import '../Icons/DoubleChevronRight.js';
import '../Icons/DoubleDirectionDown.js';
import '../Icons/DoubleDirectionUp.js';
import '../Icons/Download.js';
import '../Icons/Edit.js';
import '../Icons/ExclamationMark.js';
import '../Icons/ExclamationMarkFilled.js';
import '../Icons/ExternalLink.js';
import '../Icons/EyeClosed.js';
import '../Icons/EyeOpen.js';
import '../Icons/Fingerprint.js';
import '../Icons/Folder.js';
import '../Icons/Forever.js';
import '../Icons/Funnel.js';
import '../Icons/GooglePlay.js';
import '../Icons/Iban.js';
import '../Icons/Id.js';
import '../Icons/Info.js';
import '../Icons/InfoFilled.js';
import '../Icons/Instant.js';
import '../Icons/Ip.js';
import '../Icons/Link.js';
import '../Icons/List.js';
import '../Icons/Mail.js';
import '../Icons/Menu.js';
import '../Icons/Message.js';
import '../Icons/MessageDot.js';
import '../Icons/Onboarding.js';
import '../Icons/Padlock.js';
import '../Icons/PadlockOpen.js';
import '../Icons/Percent.js';
import '../Icons/Play.js';
import '../Icons/PowerOff.js';
import '../Icons/ProcessCompleted.js';
import '../Icons/ProcessCountEight.js';
import '../Icons/ProcessCountFive.js';
import '../Icons/ProcessCountFour.js';
import '../Icons/ProcessCountNineAndMore.js';
import '../Icons/ProcessCountOne.js';
import '../Icons/ProcessCountSeven.js';
import '../Icons/ProcessCountSix.js';
import '../Icons/ProcessCountThree.js';
import '../Icons/ProcessCountTwo.js';
import '../Icons/ProcessFailed.js';
import '../Icons/ProcessInProgress.js';
import '../Icons/ProcessNotStarted.js';
import '../Icons/ProcessPartialInProgress.js';
import '../Icons/ProcessPaused.js';
import '../Icons/Profile.js';
import '../Icons/Progress.js';
import '../Icons/Provider.js';
import '../Icons/QuestionMark.js';
import '../Icons/QuestionMarkFilled.js';
import '../Icons/Remove.js';
import '../Icons/Repeat.js';
import '../Icons/Reset.js';
import '../Icons/RoundArrow.js';
import '../Icons/RoundArrowFilled.js';
import '../Icons/RoundCheckOutlined.js';
import '../Icons/RoundCheckOutlinedFilled.js';
import '../Icons/RoundClose.js';
import '../Icons/RoundCloseFilled.js';
import '../Icons/RoundLeft.js';
import '../Icons/RoundLeftFilled.js';
import '../Icons/RoundMinus.js';
import '../Icons/RoundMinusFilled.js';
import '../Icons/RoundPlus.js';
import '../Icons/RoundPlusFilled.js';
import '../Icons/RoundRight.js';
import '../Icons/RoundRightFilled.js';
import '../Icons/Settings.js';
import '../Icons/SettingsCog.js';
import '../Icons/Shield.js';
import StarFilled from '../Icons/StarFilled.js';
import StarOutlined from '../Icons/StarOutlined.js';
import '../Icons/Success.js';
import '../Icons/Timer.js';
import '../Icons/Trash.js';
import '../Icons/Upload.js';
import '../Icons/User.js';
import '../Icons/VerticalDots.js';
import '../Icons/World.js';
import '../Icons/Wrench.js';
import '../Icons/Zoom.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const SelectCustomerItem = forwardRef(({ customer, id, isFavorite, onClick, onIconClick, isDisabled, isFavoriteDisabled, isFavoriteVisible = true, "data-testid": dataTestId, }, ref) => {
    return (jsxs(Wrapper, { "$isDisabled": isDisabled, "data-testid": dataTestId, ref: ref, onClick: !isDisabled ? onClick : undefined, children: [jsxs(Labels, { sx: { cursor: isDisabled ? "default" : "pointer" }, children: [jsx(Tooltip, { placement: "right", title: jsx(CustomerLabel, { "$isDisabled": isDisabled, sx: { color: theme.palette.text.white }, children: customer }), arrow: true, showOnlyOnEllipsis: true, children: jsx(CustomerLabel, { "$isDisabled": isDisabled, children: customer }) }), jsx(Tooltip, { placement: "right", title: jsx(IdLabel, { sx: { color: theme.palette.text.white }, children: id }), arrow: true, showOnlyOnEllipsis: true, children: jsx(IdLabel, { children: id }) })] }), isFavoriteVisible && (jsx(IconWrapper, { "$isDisabled": isFavoriteDisabled, "$isFavorite": isFavorite, onClick: !isFavoriteDisabled ? onIconClick : undefined, children: isFavorite ? (jsx(StarFilled, { "data-testid": `${dataTestId}-star-filled-icon`, shouldScale: true })) : (jsx(StarOutlined, { "data-testid": `${dataTestId}-star-outlined-icon`, shouldScale: true })) }))] }));
});
SelectCustomerItem.displayName = "SelectCustomerItem";
const Wrapper = styled("li")(({ theme, $isDisabled }) => (Object.assign({ display: "flex", justifyContent: "space-between", padding: theme.spacing(1.25, 2.5), borderBottom: `1px solid ${theme.palette.ui50}`, "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.05),
    }, "&:active": {
        backgroundColor: alpha(theme.palette.primary.main, 0.1),
    } }, ($isDisabled && {
    color: theme.palette.text.low,
    backgroundColor: alpha(theme.palette.ui50, 0.5),
    "&:hover, &:active": {
        backgroundColor: alpha(theme.palette.ui50, 0.5),
    },
    svg: {
        color: theme.palette.text.low,
    },
}))));
const Labels = styled("div")({
    display: "flex",
    flexDirection: "column",
    cursor: "default",
    overflow: "hidden",
});
const CustomerLabel = styled(Typography)(({ theme, $isDisabled }) => ({
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "20px",
    color: $isDisabled ? theme.palette.text.low : theme.palette.text.primary,
}));
const IdLabel = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 300,
    lineHeight: "16px",
    padding: "0 2px 0 0",
    color: theme.palette.text.low,
}));
const IconWrapper = styled("div")(({ theme, $isDisabled, $isFavorite }) => ({
    display: "flex",
    cursor: $isDisabled ? "default" : "pointer",
    color: theme.palette.text.low,
    height: 16,
    "& > :first-child": Object.assign(Object.assign({ fontSize: 16, color: theme.palette.ui60 }, ($isFavorite && {
        color: theme.palette.primary.main,
    })), ($isDisabled && {
        color: theme.palette.text.low,
    })),
}));

export { SelectCustomerItem };
//# sourceMappingURL=SelectCustomerItem.js.map
